<template>
  <Layout>
    <v-row>
      <v-col class="d-flex justify-start">
        <v-btn
          elevation="2"
          @click="$router.push({ name: 'Dashboard' })"
        >
          ย้อนกลับ
        </v-btn>
      </v-col>
    </v-row>
    <br />
    <v-card elevation="2" outlined shaped tile class="px-2 py-2">
      <v-card-title>แก้ไขรายการนับสินค้า</v-card-title>
      <template v-if="loading">
        <v-skeleton-loader v-bind="attrs" type="article, actions">
        </v-skeleton-loader>
      </template>
      <template v-else>
        <v-form v-model="valid" @submit.prevent="submit">
          <v-container>
            <v-row>
              <v-col cols="12" lg="8">
                <v-text-field
                  v-model="jobName"
                  :counter="100"
                  label="ชื่องาน"
                  required
                  readonly
                  disabled
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="heading-form">วัน-เวลาในการนับสินค้า</div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-dialog
                  v-model="modal"
                  ref="dialog"
                  persistent
                  disabled
                  width="290px"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-combobox
                      v-model="dates"
                      v-bind="attrs"
                      label="วันที่"
                      placeholder="กรอกวันที่ตามด้วย ,(comma) เพื่อใส่วันที่ต่อไป"
                      chips
                      multiple
                      outlined
                      hide-details
                      disabled
                      :delimiters="[',', ' ']"
                    >
                      <template v-slot:append>
                        <v-icon class="mr-2" color="grey">
                          mdi-calendar
                        </v-icon>
                      </template>
                      <template
                        v-slot:selection="{
                          attrs,
                          item,
                          select,
                          selected,
                        }"
                      >
                        <v-chip
                          v-bind="attrs"
                          small-chips
                          disabled
                          :input-value="selected"
                          @click="select"
                          @click:close="remove(item)"
                        >
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-2">
              <v-col cols="12" lg="8">
                <v-row align="center">
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="fromHH"
                      :items="hours"
                      label="ชั่วโมง"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="fromMM"
                      :items="minutes"
                      label="นาที"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="auto" sm="1" class="mb-sm-4">
                    ถึง
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="endHH"
                      :items="hours2"
                      label="ชั่วโมง"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="endMM"
                      :items="minutes"
                      label="นาที"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- <div class="d-flex justify-start my-2">
              BU
            </div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-select
                  @change="onChangeBU"
                  v-model="selectBU"
                  :items="bu"
                  disabled
                  label="Select BU"
                  item-text="bu_name"
                  item-value="bu_id"
                ></v-select>
              </v-col>
            </v-row> -->

            <div class="heading-form">เลือกสาขา</div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-autocomplete
                  v-model="selectStore"
                  :items="storeData"
                  disabled
                  chips
                  label="สาขา"
                  item-text="store_name"
                  item-value="store_id"
                  multiple
                  outlined
                  small-chips
                  hide-details
                ></v-autocomplete>

                <!-- <v-select
                @change="onChangeStore"
                v-model="selectStore"
                :items="storeData"
                label="Select Store"
               item-text="store_name"
                item-value="store_id"
              ></v-select> -->
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" lg="8">
                <div class="ratio-condition-container">
                  <v-checkbox
                    v-model="useRatioCondition"
                    label="กำหนดสัดส่วนการนับสินค้า (ของพนักงานคนหลัก)"
                    class="my-0"
                    hide-details
                    disabled
                    readonly
                  ></v-checkbox>

                  <template v-if="useRatioCondition">
                    <div class="heading-form mt-4">
                      สัดส่วนการนับสินค้า (ของพนักงานคนหลัก)
                    </div>
                    <v-row>
                      <v-col cols="12">
                        <v-slider
                          v-model="mainRatio"
                          class="align-center"
                          :max="100"
                          :min="1"
                          hide-details
                          disabled
                          readonly
                        >
                          <template v-slot:append>
                            <v-text-field
                              v-model="mainRatio"
                              class="mt-0 pt-0"
                              hide-details
                              single-line
                              disabled
                              readonly
                              type="number"
                              style="width: 60px"
                            >
                              <template v-slot:append> % </template>
                            </v-text-field>
                          </template>
                        </v-slider>
                      </v-col>
                    </v-row>

                    <div class="heading-form">เลือกตำแหน่ง</div>
                    <v-row>
                      <v-col cols="12">
                        <div class="select-container">
                          <v-autocomplete
                            v-model="filterPosition"
                            :items="positions"
                            label="ตำแหน่ง"
                            chips
                            small-chips
                            multiple
                            outlined
                            hide-details
                            disabled
                            readonly
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>

                    <v-checkbox
                      v-model="sortFifo"
                      label="เรียงตาม FIFO"
                      hide-details
                      disabled
                      readonly
                      class="mt-4 mb-0 heading-form"
                    ></v-checkbox>
                  </template>
                </div>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="heading-form">เลือกแบรนด์</div>
            <v-row>
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectBrand"
                    :items="brands"
                    chips
                    small-chips
                    label="แบรนด์"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="brands.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกแบรนด์ทั้งหมด (${brands.length} แบรนด์)`"
                            :value="
                              selectBrand.length === brands.length
                            "
                            :indeterminate="
                              selectBrand.length > 0 &&
                              selectBrand.length < brands.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectBrand =
                                selectBrand.length === brands.length
                                  ? []
                                  : brands.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectBrand = []">
                    ล้างแบรนด์
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <div class="heading-form">เลือกหมวดหมู่</div>
            <v-row align="center">
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectCategory"
                    :items="categories"
                    chips
                    small-chips
                    label="หมวดหมู่"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="categories.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกหมวดหมู่ทั้งหมด (${categories.length} หมวดหมู่)`"
                            :value="
                              selectCategory.length ===
                              categories.length
                            "
                            :indeterminate="
                              selectCategory.length > 0 &&
                              selectCategory.length <
                                categories.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectCategory =
                                selectCategory.length ===
                                categories.length
                                  ? []
                                  : categories.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectCategory = []">
                    ล้างหมวดหมู่
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="heading-form">เลือกหมวดหมู่ย่อย</div>
            <v-row class="py-2">
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectSubCateogry"
                    :items="subCategories"
                    chips
                    small-chips
                    label="หมวดหมู่ย่อย"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="subCategories.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกหมวดหมู่ย่อยทั้งหมด (${subCategories.length} หมวดหมู่ย่อย)`"
                            :value="
                              selectSubCateogry.length ===
                              subCategories.length
                            "
                            :indeterminate="
                              selectSubCateogry.length > 0 &&
                              selectSubCateogry.length <
                                subCategories.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectSubCateogry =
                                selectSubCateogry.length ===
                                subCategories.length
                                  ? []
                                  : subCategories.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectSubCateogry = []">
                    ล้างหมวดหมู่ย่อย
                  </v-btn>
                </div>
              </v-col>
              <!-- <v-col cols="2" v-for="item in subCategories" :key="item">
              <v-checkbox
                v-model="selectSubCateogry"
                :label="item"
                color="blue"
                :value="item"
                hide-details
              ></v-checkbox>
            </v-col> -->
            </v-row>
            <div class="heading-form">โปรดักโค้ด (SKU)</div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-combobox
                  label="โปรดักโค้ด"
                  v-model="skus"
                  :delimiters="[',']"
                  chips
                  clearable
                  multiple
                  outlined
                  append-icon=""
                  placeholder="กรอก sku ตามด้วย ,(comma) เพื่อใส่ sku ต่อไป ex. sku1,sku2"
                >
                  <template
                    v-slot:selection="{
                      attrs,
                      item,
                      select,
                      selected,
                    }"
                  >
                    <v-chip
                      small
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeSku(item)"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <WarnSection />
            <!-- Submit -->
            <v-btn class="mr-4" @click="submit" color="primary">
              บันทึก
            </v-btn>
            <!-- <v-btn @click="clear"> clear </v-btn> -->
          </v-container>
        </v-form>
        <v-snackbar v-model="toastSuccess" :timeout="5000">
          บันทึกสำเร็จ
          <template v-slot:action="{ attrs }">
            <v-btn
              color="primary"
              text
              v-bind="attrs"
              @click="toastSuccess = false"
            >
              ปิด
            </v-btn>
          </template>
        </v-snackbar>
      </template>
    </v-card>
  </Layout>
</template>

<script>
import WarnSection from '@/components/WarnSection'
import Layout from '@/components/Layout'
// import InputDatePicker from '@/components/InputDatePicker'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      jobDetail: (state) => state.job.jobDetail?.stores,
      jobDetailLoading: (state) => state.job.isLoading,
      storeData: (state) => state.masterData.store,
      buData: (state) => state.masterData.bu,
      categoryData: (state) => state.masterData.category,
      positionsData: (state) => state.masterData.positions,
      jobConfig: (state) =>
        state.job.jobDetail?.job?.config
          ? JSON.parse(state.job.jobDetail?.job?.config)
          : null,
    }),
    loading() {
      return this.jobDetailLoading
    },
    positions() {
      return this.categoryData?.positions ?? []
    },
    categories() {
      return (
        this.categoryData?.categories.map((i) => i.category_name) ??
        []
      )
    },
    brands() {
      return this.categoryData?.brands ?? []
    },
    subCategories() {
      const all = this.categoryData?.categories.reduce(
        (subCat, i) => {
          subCat = [...subCat, ...i?.sub_cat]
          return subCat
        },
        [],
      )
      return all?.filter(
        (value, index, self) => self?.indexOf(value) === index,
      )
    },
    hours() {
      let hh = []
      for (let i = 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(`${i}`)
      }
      return hh
    },
    minutes() {
      return ['00', '15', '30', '45']
    },
    hours2() {
      let hh = []
      for (let i = +this.fromHH + 1 ?? 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(`${i}`)
      }
      return hh
    },
    jobDetailName() {
      return this?.jobDetail?.[0]?.name
    },
    jobDetailStoreId() {
      return this?.jobDetail?.[0]?.store_id
    },
  },

  components: {
    Layout,
    WarnSection,
    // InputDatePicker,
  },

  watch: {
    jobDetail() {
      // Set Default Value from api
      this.jobName = this.jobDetailName

      // Store
      const store = this?.jobDetail?.map((item) => {
        return {
          store_id: item.store_id,
          store_name: item.store_name,
          sku: item.sku ?? [],
        }
      })
      this.storeData = store
      this.selectStore = store
        ?.map((i) => i.store_id)
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )
      this.dates = this.jobDetail
        ?.map((i) => i.date)
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )

      this.selectBrand = this.jobDetail
        ?.reduce((acc, i) => {
          return acc?.concat(i?.product_brand)
        }, [])
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )

      this.selectCategory = this.jobDetail
        ?.reduce((acc, i) => {
          return acc?.concat(i?.category)
        }, [])
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )

      this.selectSubCateogry = this.jobDetail
        ?.reduce((acc, i) => {
          return acc?.concat(i?.sub_cat)
        }, [])
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )

      this.skus =
        store
          ?.reduce((acc, i) => {
            return acc?.concat(
              Array.isArray(i?.sku)
                ? i?.sku
                : i?.sku?.split(`,`) || [],
            )
          }, [])
          .filter(
            (value, index, self) =>
              self?.indexOf(value) === index && value !== '',
          ) ?? []

      this.fromHH = this?.jobDetail?.[0]?.start_time.split(':')[0]
      this.fromMM = this?.jobDetail?.[0]?.start_time.split(':')[1]
      this.endHH = this?.jobDetail?.[0]?.end_time.split(':')[0]
      this.endMM = this?.jobDetail?.[0]?.end_time.split(':')[1]

      if (this.jobConfig) {
        this.useRatioCondition =
          this.jobConfig?.main_ratio !== undefined
        this.mainRatio = this.jobConfig?.main_ratio || 1
        this.filterPosition = this.jobConfig?.filter_position || []
        this.sortFifo = this.jobConfig?.sort_fifo === 1 ? true : false
      }
    },
  },

  data() {
    return {
      selectBU: '',
      selectStore: '',
      jobName: this.jobDetailName,
      jobDate: null,
      dates: [],
      menu1: false,
      menu2: false,
      selectCategory: [],
      selectSubCateogry: [],
      selectBrand: [],
      fromHH: '',
      fromMM: '',
      endHH: '',
      endMM: '',
      toastSuccess: false,
      skus: [],
      useRatioCondition: false,
      sortFifo: false,
      mainRatio: 1,
      filterPosition: [],
    }
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
    }
    await this.$store.dispatch('job/getJobDetail', payload)
    this.$store.dispatch('masterData/getBu')
    this.$store.dispatch('masterData/getStore')
    if (this.jobDetailStoreId) {
      this.$store.dispatch('masterData/getCategory', {
        storeId: this.jobDetailStoreId,
      })
    }
  },

  methods: {
    clear() {
      this.jobDate = ''
      this.jobName = ''
      this.dates = []
      this.selectBU = ''
    },

    onChangeBU() {
      this.getCategory()
    },

    onChangeStore() {
      this.getCategory()
    },

    getCategory() {
      this.$store.dispatch('masterData/getCategory', {
        buId: this.selectBU,
      })
      // TODO: Delete Select Store choice storeId or buId
      // if (this.selectStore) {
      //   this.$store.dispatch('masterData/getCategory', {
      //     storeId: this.selectStore,
      //   })
      // } else {
      //   this.$store.dispatch('masterData/getCategory', {
      //     buId: this.selectBU,
      //   })
      // }
    },
    async submit() {
      const payload = {
        job_id: this.$route.params.id,
        job_name: this.jobName,
        start_time: `${this.fromHH}:${this.fromMM}`,
        end_time: `${this.endHH}:${this.endMM}`,
        'product_brands[]': this.selectBrand,
        'categories[]': this.selectCategory,
        'sub_cats[]': this.selectSubCateogry,
        sku: this.skus,
      }
      // TODO Request Create
      await this.$store.dispatch('job/updateJob', payload)
      this.toastSuccess = true
    },

    removeSku(val) {
      this.skus = this.skus.filter((i) => i !== val)
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-list-item__title {
  text-align: left !important;
}
</style>
